export default {
  header: 'Cost',
  total: 'Total cost',
  perLiter: 'Cost per liter',
  perBottle075: 'Cost per bottle (0.75)',
  perBottle033: 'Cost per bottle (0.33)',
  perCan033: 'Cost per can (0.33)',
};
